<template>
  <transition name="np-loading-fade">
    <div v-if="visible" class="np-loading-overlay" :class="{ inline: inline }">
      <div class="np-loading-card">
        <div class="np-loading-spinner"></div>
        <p v-if="label" class="np-loading-text">{{ label }}</p>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "loading-overlay",
  props: {
    // Show/hide the overlay
    visible: {
      type: Boolean,
      default: false
    },
    // Optional text shown below the spinner
    label: {
      type: String,
      default: "Loading..."
    },
    // When true, positions relative to parent instead of the full viewport
    inline: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped lang="scss">
.np-loading-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.65);
  backdrop-filter: blur(3px);

  // Inline variant — sits inside a relatively-positioned parent
  &.inline {
    position: absolute;
    border-radius: inherit;
  }
}

.np-loading-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  background: #fff;
  border-radius: 16px;
  padding: 36px 48px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
}

.np-loading-spinner {
  width: 44px;
  height: 44px;
  border: 4px solid #e8f7f5;
  border-top-color: #afdfd3;
  border-radius: 50%;
  animation: np-spin 0.8s linear infinite;
}

@keyframes np-spin {
  to { transform: rotate(360deg); }
}

.np-loading-text {
  margin: 0;
  font-size: 0.95rem;
  color: #6b7280;
  letter-spacing: 0.01em;
}

// Fade transition
.np-loading-fade-enter-active,
.np-loading-fade-leave-active {
  transition: opacity 0.25s ease;
}
.np-loading-fade-enter,
.np-loading-fade-leave-to {
  opacity: 0;
}
</style>
